module.exports = __webpack_public_path__ + "static/illustration-5da92266c5d6e64c321d5d82bf6821a3.svg";